// Nederlands (default). Bron van waarheid voor de sleutelvorm — en.ts moet
// dezelfde structuur volgen. Vlakke, dotted keys.
export const nl = {
  "app.name": "Datow",
  "app.payoff": "Your data in motion", // blijft Engels

  // Navigatie
  "navgroup.beheer": "Beheer",
  "navgroup.producten": "Producten",
  "navgroup.inzicht": "Inzicht",
  "nav.overzicht": "Overzicht",
  "nav.abonnementen": "Abonnementen",
  "nav.pakketten": "Pakketten",
  "nav.klanten": "Klanten",
  "nav.leads": "Leads",
  "nav.datalift": "DataLift",
  "nav.databridge": "DataBridge",
  "nav.datadocs": "DataDocs",
  "nav.dataapps": "DataApps",
  "nav.datacloud": "DataCloud",
  "nav.rapportages": "Rapportages",
  "nav.auditlog": "Audit-log",

  // Algemene acties
  "action.new": "Nieuw",
  "action.newAbonnement": "Nieuw abonnement",
  "action.newPakket": "Nieuw pakket",
  "action.newKlant": "Nieuwe klant",
  "action.edit": "Bewerken",
  "action.cancel": "Annuleren",
  "action.save": "Opslaan",
  "action.create": "Aanmaken",
  "action.search": "Zoeken",
  "action.export": "Exporteren",
  "action.verlengen": "Verlengen",
  "action.opzeggen": "Opzeggen",
  "action.viewAll": "Volledig",
  "action.back": "Terug",
  "action.copy": "Kopiëren",

  // Gebruikersmenu
  "user.profile": "Profiel",
  "user.preferences": "Voorkeuren",
  "user.language": "Taal",
  "user.shortcuts": "Sneltoetsen",
  "user.logout": "Uitloggen",

  // Statuslabels — abonnement (7 staten)
  "status.proef": "Proef",
  "status.inbehandeling": "In behandeling",
  "status.actief": "Actief",
  "status.verlenging": "Ter verlenging",
  "status.betaling": "Wacht op betaling",
  "status.opgezegd": "Opgezegd",
  "status.verlopen": "Verlopen",
  // Statuslabels — onderdeel (7 staten); proef/actief/opgezegd zijn gedeeld
  "status.besteld": "Besteld",
  "status.implementatie": "In implementatie",
  "status.opgeleverd": "Opgeleverd",
  "status.vervallen": "Vervallen",

  // Env-banner (niet-productie)
  "banner.acc": "Acceptatieomgeving",
  "banner.local": "Ontwikkelomgeving",
  "banner.note": "gegevens hier staan los van productie",

  // Login / gateway
  "login.title": "Inloggen",
  "login.lede": "Welkom terug bij de Datow Backend.",
  "login.employees": "Medewerkers",
  "login.microsoft": "Inloggen met Microsoft",
  "login.ssoNote": "Single sign-on met je Datow-account · MFA via Entra ID.",
  "login.or": "of",
  "login.email": "E-mailadres",
  "login.password": "Wachtwoord",
  "login.emailLogin": "Inloggen met e-mail",
  "login.emailSoon": "E-mail/wachtwoord-login is binnenkort beschikbaar.",
  "login.partner": "Partnerportaal",
  "login.partnerBadge": "Binnenkort",
  "login.partnerBody": "Toegang voor koppelpartners en resellers. Nog niet beschikbaar.",
  "login.partnerButton": "Inloggen als partner",
  "login.help": "Nog geen account? Neem contact op met beheer",
  "login.contactEmail": "info@datow.nl",
  "login.devTitle": "Ontwikkelaarslogin (mock)",
  "login.devEmail": "E-mailadres",
  "login.devRoles": "Rollen",
  "login.devLogin": "Inloggen (mock)",

  // Overzicht (dashboard)
  "overzicht.title": "Overzicht",
  "overzicht.subtitle": "De actuele staat van je abonnementenportefeuille.",
  "overzicht.kpi.actief": "Actieve abonnementen",
  "overzicht.kpi.maandomzet": "Maandomzet",
  "overzicht.kpi.proef": "Lopende proeven",
  "overzicht.kpi.aandacht": "Vraagt aandacht",
  "overzicht.attention.title": "Vraagt aandacht",
  "overzicht.attention.empty": "Niets dat aandacht vraagt — alles loopt.",
  "overzicht.distribution.title": "Verdeling per productgroep",
  "overzicht.kpi.wachtOpDatum": "Wacht op ingangsdatum",
  "overzicht.recent.title": "Recente abonnementen",

  // Abonnementen
  "abonnementen.title": "Abonnementen",
  "abonnementen.view.alle": "Alle",
  "abonnementen.view.actief": "Actief",
  "abonnementen.view.proef": "Proef",
  "abonnementen.view.verlenging": "Ter verlenging",
  "abonnementen.view.betaling": "Wacht op betaling",
  "abonnementen.search": "Zoek abonnement of klant…",
  "abonnementen.col.abonnement": "Abonnement",
  "abonnementen.col.pakket": "Onderdelen",
  "abonnementen.col.status": "Status",
  "abonnementen.col.startdatum": "Startdatum",
  "abonnementen.col.verlengtOp": "Verlengt op",
  "abonnementen.col.maandbedrag": "Maandbedrag",
  "abonnementen.empty.title": "Geen abonnementen gevonden",
  "abonnementen.empty.body": "Pas je filters aan of maak een nieuw abonnement aan.",
  "abonnementen.selected": "{{count}} geselecteerd",

  // Abonnement — dossier
  "abonnement.tab.overzicht": "Overzicht",
  "abonnement.tab.contract": "Contract",
  "abonnement.tab.tijdlijn": "Tijdlijn",
  "abonnement.tab.audit": "Audit-log",
  "abonnement.section.samenvatting": "Samenvatting",
  "abonnement.section.pakket": "Onderdelen",
  "abonnement.section.contract": "Contract",
  "abonnement.section.tijdlijn": "Tijdlijn",
  "abonnement.section.partijen": "Partijen",
  "abonnement.section.audit": "Audit-log",
  "abonnement.field.klant": "Klant",
  "abonnement.field.pakket": "Onderdelen",
  "abonnement.field.jaarbedrag": "Jaarbedrag",
  "abonnement.field.opzegbaarTot": "Opzegbaar tot",
  "abonnement.field.status": "Status",
  "abonnement.field.maandbedrag": "Maandbedrag",
  "abonnement.field.startdatum": "Startdatum",
  "abonnement.field.verlengtOp": "Verlengt op",
  "abonnement.field.looptijd": "Looptijd",
  "abonnement.field.opzegtermijn": "Opzegtermijn",
  "abonnement.field.facturatie": "Facturatie",
  "abonnement.field.betaalwijze": "Betaalwijze",
  "abonnement.field.maanden": "{{count}} maanden",
  "abonnement.field.maanden_one": "{{count}} maand",
  "abonnement.changeStatus": "Status wijzigen",
  "abonnement.moveTo": "Verplaats naar",

  // Nieuw abonnement
  "abonnementNieuw.title": "Nieuw abonnement",
  "abonnementNieuw.step.klant": "Klant",
  "abonnementNieuw.step.pakket": "Onderdelen",
  "abonnementNieuw.step.looptijd": "Looptijd & start",
  "abonnementNieuw.step.facturatie": "Facturatie",
  "abonnementNieuw.summary": "Samenvatting",
  "abonnementNieuw.summaryNote":
    "Het abonnement start in de status In behandeling. Activeer het zodra de koppeling gereed is.",
  "abonnementNieuw.submit": "Abonnement aanmaken",
  "abonnementNieuw.alsProef": "Als proef aanmaken — € 0, nog geen bestelling",
  "abonnementNieuw.geenOnderdelen": "Kies minstens één onderdeel uit de prijslijst.",

  // Prijslijst (de catalogus — schaalt naar 150–200 codes)
  "pakketten.title": "Prijslijst",
  "pakketten.subtitle": "De verkoopbare onderdelen: productgroep, model en niveau, met één standaardprijs.",
  "pakketten.perMaand": "per maand",
  "pakketten.perJaar": "per jaar",
  "pakketten.search": "Zoek op productcode, model of naam…",
  "pakketten.col.productcode": "Productcode",
  "pakketten.col.pakket": "Onderdeel",
  "pakketten.col.model": "Model",
  "pakketten.col.niveau": "Niveau",
  "pakketten.col.maandtarief": "Standaardprijs",
  "pakketten.col.jaartarief": "Per jaar",
  "pakketten.col.inGebruik": "In gebruik",
  "pakketten.col.status": "Status",
  "pakketten.filter.groep": "Productgroep",
  "pakketten.filter.niveau": "Niveau",
  "pakketten.filter.alle": "Alle",
  "pakketten.status.actief": "Actief",
  "pakketten.status.concept": "Concept",
  "pakketten.status.uitgefaseerd": "Uitgefaseerd",
  "pakketten.aantalInGebruik": "{{count}} in gebruik",
  "pakketten.empty.title": "Geen catalogusregels gevonden",
  "pakketten.empty.body": "Pas je filters aan of zoek op een andere productcode.",
  "pakketten.grootboek": "Grootboek",
  "pakketten.grootboekLeeg": "nog niet ingesteld",
  "pakketten.jaarNote": "Het jaarbedrag is 12 × het maandbedrag — geen korting op vooruitbetaling.",
  "pakketten.uitgefaseerdNote":
    "Uitgefaseerde codes blijven bestaan zodat oude onderdelen en facturen herleidbaar blijven, maar zijn niet meer te kiezen.",

  // Onderdelen (de regels op een abonnement)
  "onderdelen.title": "Onderdelen",
  "onderdelen.subtitle": "De pakketten binnen dit abonnement, elk met een eigen status en ingangsdatum.",
  "onderdelen.col.onderdeel": "Onderdeel",
  "onderdelen.col.productcode": "Productcode",
  "onderdelen.col.status": "Status",
  "onderdelen.col.bedrag": "Overeengekomen",
  "onderdelen.col.standaard": "Standaardprijs",
  "onderdelen.col.afwijking": "Afwijking",
  "onderdelen.col.ingangsdatum": "Ingangsdatum",
  "onderdelen.col.eerstePeriode": "Eerste periode",
  "onderdelen.opStandaard": "op standaard",
  "onderdelen.geenDatum": "nog niet bekend",
  "onderdelen.wachtOpDatum": "Wacht op ingangsdatum",
  "onderdelen.wachtOpDatumBody":
    "Verkocht, maar zonder ingangsdatum — en dus nog niet gefactureerd.",
  "onderdelen.proRataNote": "{{dagen}} van {{totaal}} dagen tot de prolongatiedatum",
  "onderdelen.volledigePeriode": "volledige periode",
  "onderdelen.opgevolgdDoor": "Opgevolgd door een hoger niveau",
  "onderdelen.vervangt": "Vervangt een eerder onderdeel",
  "onderdelen.empty.title": "Nog geen onderdelen",
  "onderdelen.empty.body": "Voeg een onderdeel uit de prijslijst toe aan dit abonnement.",
  "onderdelen.add": "Onderdeel toevoegen",
  "onderdelen.totaal": "Totaal per maand",

  // Leads (verkoopkansen) & terugbellijst
  "leads.title": "Leads",
  "leads.subtitle": "Verkoopkansen met een verwacht bedrag en een verwachte periode, plus wie er terug moet worden gebeld.",
  "leads.new": "Nieuwe lead",
  "leads.terugbellijst": "Terug te bellen",
  "leads.periode.week": "Deze week",
  "leads.periode.maand": "Deze maand",
  "leads.periode.kwartaal": "Dit kwartaal",
  "leads.achterstallig": "Achterstallig — de datum is voorbij",
  "leads.afvinken": "Afvinken",
  "leads.geenActies": "Niemand terug te bellen",
  "leads.geenActiesBody": "Er staan geen openstaande vervolgacties in deze periode.",
  "leads.geenForecast": "Nog geen openstaande leads om een verwachting op te bouwen.",
  "leads.status.open": "Open",
  "leads.status.gewonnen": "Gewonnen",
  "leads.status.verloren": "Verloren",
  "leads.col.kwalificatie": "A/B/C",
  "leads.col.omschrijving": "Omschrijving",
  "leads.col.verwachtePeriode": "Verwacht",
  "leads.col.verwachtBedrag": "Verwacht bedrag",
  "leads.col.status": "Status",
  "leads.col.notities": "Notities",
  "leads.col.terugbellenOp": "Terugbellen op",
  "leads.col.actie": "Actie",
  "leads.empty.title": "Geen leads gevonden",
  "leads.empty.body": "Pas je filters aan of leg een nieuwe verkoopkans vast.",
  "leads.forecastNote":
    "De verwachte omzet is ongewogen: A/B/C is een kwalificatie, geen kans. Een weging per klasse is nog een keuze.",

  // Contactmomenten (gespreksnotities & vervolgacties)
  "momenten.title": "Gespreksnotities",
  "momenten.notitie": "Notitie",
  "momenten.vervolgactie": "Vervolgactie",
  "momenten.geen": "Nog geen notities vastgelegd.",
  "momenten.terugbellenOp": "Terugbellen op {{datum}}",
  "momenten.afgerond": "Afgerond",
  "momenten.add": "Notitie toevoegen",

  // Klantdossier
  "klant.dossier": "Klantdossier",
  "klant.section.contactpersonen": "Contactpersonen",
  "klant.section.abonnementen": "Abonnementen",
  "klant.section.tijdlijn": "Tijdlijn",
  "klant.section.gegevens": "Gegevens",
  "klant.field.kvk": "KVK",
  "klant.field.plaats": "Plaats",
  "klant.field.sinds": "Klant sinds",
  "klant.field.type": "Type",
  "klant.contact.primair": "primair",
  "klant.contact.facturatie": "facturatie",
  "klant.contact.ondertekenaar": "ondertekenaar",
  "klant.contact.geen": "Nog geen contactpersonen vastgelegd.",
  "klant.geenAbonnementen": "Deze klant heeft nog geen abonnement.",

  // Klanten
  "klanten.title": "Klanten",
  "klanten.view.alle": "Alle",
  "klanten.view.klant": "Klant",
  "klanten.view.prospect": "Prospect",
  "klanten.search": "Zoek klant, plaats of KVK…",
  "klanten.col.klant": "Klant",
  "klanten.col.kvk": "KVK",
  "klanten.col.contact": "Contactpersoon",
  "klanten.col.contacten": "Contactpersonen",
  "klanten.col.abonnementen": "Abonnementen",
  "klanten.col.sinds": "Klant sinds",
  "klanten.col.type": "Type",
  "klanten.type.klant": "Klant",
  "klanten.type.prospect": "Prospect",
  "klanten.contactUnassigned": "— nog toewijzen",

  // Algemeen
  "common.loading": "Laden…",
  "common.results": "{{count}} resultaten",
  "common.results_one": "{{count}} resultaat",
  "common.page": "Pagina {{page}}",
  "common.of": "van",
  "common.previous": "Vorige",
  "common.next": "Volgende",
  "common.error": "Er ging iets mis",
  "common.retry": "Opnieuw proberen",
  "common.none": "—",
} as const;
